import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useUpdateMeMutation } from "src/api/services/patientApi";
import { usePatient } from "src/context/PatientProvider";
import { Database } from "src/supabase.types";

type Languages = Database["public"]["Enums"]["languages"];
const isLanguage = (value: string): value is Languages => {
  return value === "en" || value === "es" || value === "pt";
};

interface Props {
  size?: "small" | "medium";
}

const SelectLanguage = ({ size = "medium" }: Props) => {
  const preferredLanguage = usePatient((p) => p.profile.language);
  const [language, setLanguage] = useState<Languages | null>(preferredLanguage);
  const [updateMe] = useUpdateMeMutation();
  const { i18n } = useTranslation();

  const handleChange = useCallback(
    (event: SelectChangeEvent<Languages>) => {
      const newLanguage = event.target.value;
      if (isLanguage(newLanguage)) {
        setLanguage(newLanguage);
        i18n.changeLanguage(newLanguage);

        updateMe({
          profile: {
            language: newLanguage,
          },
        });
      }
    },
    [i18n, updateMe]
  );

  const style = useMemo(() => {
    if (size === "small") {
      return { borderRadius: "4px", height: "30px" };
    }

    return { borderRadius: "8px", height: "40px" };
  }, [size]);

  return (
    <Select value={language ?? ""} sx={style} onChange={handleChange}>
      <MenuItem value="en">EN</MenuItem>
      <MenuItem value="es">ES</MenuItem>
      <MenuItem value="pt">PT</MenuItem>
    </Select>
  );
};

export default SelectLanguage;
